<template>
  <div class="executivo-mobile" :class="{ 'dark-mode': isDark }">
    <!-- Header -->
    <header class="mobile-header">
      <div class="user-info">
        <h5 class="m-0 font-weight-bold">Visão Executiva</h5>
        <small class="text-muted" :class="{ 'text-light-muted': isDark }">Resumo do Dia</small>
      </div>
      <div class="header-actions">
        <i class="fa fa-bell-o notification-icon"></i>
      </div>
    </header>

    <!-- Swipable Content Area -->
    <div class="mobile-content-scroll">
      
      <!-- 1. VENDAS E FATURAMENTO -->
      <section class="metric-section">
        <h6 class="section-title">Vendas (Mês Atual)</h6>
        <div class="metric-card glass-card sales-card" @click="abrirResumo('vendas')" style="cursor: pointer;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="icon-circle bg-success-light text-success">
              <i class="fa fa-line-chart"></i>
            </div>
            <span class="badge badge-success rounded-pill" v-if="vendas.carregando">Carregando...</span>
          </div>
          <h2 class="metric-value">{{ vendas.totalFormatado }}</h2>
          <div class="progress-container">
            <div class="d-flex justify-content-between small mb-1">
              <span>Desempenho</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar bg-success" role="progressbar" style="width: 100%"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 2. FLUXO DE CAIXA -->
      <section class="metric-section">
        <h6 class="section-title">Tesouraria e Fluxo (10 dias)</h6>
        <div class="row no-gutters gx-2">
          <div class="col-6 pr-2">
            <div class="metric-card glass-card info-card" @click="abrirResumo('areceber')" style="cursor: pointer;">
              <div class="icon-circle bg-info-light text-info mb-2">
                <i class="fa fa-arrow-down"></i>
              </div>
              <p class="small text-muted mb-1" :class="{ 'text-light-muted': isDark }">A Receber</p>
              <h5 class="metric-value-sm text-info">{{ aReceber.totalFormatado }}</h5>
            </div>
          </div>
          <div class="col-6 pl-2">
            <div class="metric-card glass-card danger-card" @click="abrirResumo('apagar')" style="cursor: pointer;">
              <div class="icon-circle bg-danger-light text-danger mb-2">
                <i class="fa fa-arrow-up"></i>
              </div>
              <p class="small text-muted mb-1" :class="{ 'text-light-muted': isDark }">A Pagar</p>
              <h5 class="metric-value-sm text-danger">{{ aPagar.totalFormatado }}</h5>
            </div>
          </div>
        </div>
      </section>

      <!-- 3. COMPRAS E DESPESAS -->
      <section class="metric-section">
        <h6 class="section-title">Compras (Mês)</h6>
        <div class="metric-card glass-card warning-card" @click="abrirResumo('compras')" style="cursor: pointer;">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="icon-circle bg-warning-light text-warning">
              <i class="fa fa-shopping-cart"></i>
            </div>
          </div>
          <h2 class="metric-value">{{ compras.totalFormatado }}</h2>
        </div>
      </section>

      <!-- 4. LUCRATIVIDADE E IMPOSTOS -->
      <section class="metric-section">
        <h6 class="section-title">Margem e Tributário (Mês)</h6>
        <div class="metric-card glass-card dark-accent-card" @click="abrirResumo('lucro')" style="cursor: pointer;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <p class="small text-muted mb-1" :class="{ 'text-light-muted': isDark }">Lucro Total</p>
              <h4 class="metric-value text-primary">{{ lucro.totalFormatado }}</h4>
            </div>
            <div class="donut-chart-mockup">
              <!-- Visual only CSS donut -->
            </div>
          </div>
          <hr class="glass-divider">
          <div class="d-flex justify-content-between align-items-center">
            <p class="small text-muted mb-0" :class="{ 'text-light-muted': isDark }">Margem Percentual</p>
            <h6 class="mb-0 text-success">{{ lucro.percentualFormatado }}</h6>
          </div>
        </div>
      </section>

      <!-- Spacer for bottom padding -->
      <div style="height: 40px;"></div>
    </div>

    <!-- Modal de Resumo -->
    <b-modal id="modal-resumo" hide-footer :title="modalResumo.titulo" centered
             :header-bg-variant="isDark ? 'dark' : 'light'" 
             :header-text-variant="isDark ? 'light' : 'dark'"
             :body-bg-variant="isDark ? 'dark' : 'light'"
             :body-text-variant="isDark ? 'light' : 'dark'">
      <div v-if="modalResumo.carregando" class="text-center p-3">
        <b-spinner variant="primary"></b-spinner>
        <p class="mt-2 mb-0">Buscando informações...</p>
      </div>
      <div v-else>
        <ul class="list-group list-group-flush" :class="{ 'bg-dark': isDark }">
          <li class="list-group-item d-flex justify-content-between align-items-center" 
              :class="{ 'bg-dark text-light border-secondary': isDark }"
              v-for="(item, index) in modalResumo.itens" :key="index">
            <div>
              <strong class="d-block">{{ item.titulo }}</strong>
              <small :class="isDark ? 'text-secondary' : 'text-muted'">{{ item.subtitulo }}</small>
            </div>
            <span class="badge badge-primary badge-pill">{{ formatarMoeda(item.valor) }}</span>
          </li>
          <li class="list-group-item text-center text-muted" v-if="modalResumo.itens.length === 0" :class="{ 'bg-dark text-light border-secondary': isDark }">
            Nenhuma informação detalhada encontrada.
          </li>
        </ul>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardExecutivoMobile',
  data() {
    return {
      vendas: { valor: 0, totalFormatado: 'R$ 0,00', carregando: true },
      aReceber: { valor: 0, totalFormatado: 'R$ 0,00', carregando: true },
      aPagar: { topData: [], valor: 0, totalFormatado: 'R$ 0,00', carregando: true },
      compras: { valor: 0, totalFormatado: 'R$ 0,00', carregando: true },
      lucro: { valor: 0, percentual: 0, totalFormatado: 'R$ 0,00', percentualFormatado: '0%', carregando: true },
      modalResumo: {
        titulo: 'Resumo Rápido',
        carregando: false,
        itens: [] // array of { titulo, subtitulo, valor }
      }
    }
  },
  computed: {
    // Reutilizando o getter de tema já existente
    ...mapGetters('tema',{ isDarkStore: 'IS_DARK' }),
    isDark() {
      // Fallback para localStorage caso vuex não esteja populado logo no início
      const temaLocal = window.localStorage.getItem('tema');
      return this.isDarkStore || temaLocal === 'D';
    }
  },
  mounted() {
    this.fetchDashboardData();
  },
  methods: {
    formatarMoeda(valor) {
      if (!valor) return 'R$ 0,00'
      return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    fetchDashboardData() {
      // Vendas do mês
      this.$http.get('api/protected/venda/totalizarvendassemana').then(res => {
        if(res && res.data && res.data.length > 0) {
          const valor = res.data[0].VALOR || 0;
          this.vendas.valor = valor;
          this.vendas.totalFormatado = this.formatarMoeda(valor);
        }
        this.vendas.carregando = false;
        this.calcularMargem();
      }).catch(() => { this.vendas.carregando = false; });

      // A Receber 10 dias
      this.$http.get('api/protected/areceber/totalizarproximos10Dias').then(res => {
        if(res && res.data && res.data.length > 0) {
          const valor = res.data[0].VALOR || 0;
          this.aReceber.valor = valor;
          this.aReceber.totalFormatado = this.formatarMoeda(valor);
        }
        this.aReceber.carregando = false;
      }).catch(() => { this.aReceber.carregando = false; });

      // A Pagar 10 dias
      this.$http.get('api/protected/apagar/totalizarproximos10Dias').then(res => {
        if(res && res.data && res.data.length > 0) {
          const valor = res.data[0].VALOR || 0;
          this.aPagar.valor = valor;
          this.aPagar.totalFormatado = this.formatarMoeda(valor);
        }
        this.aPagar.carregando = false;
      }).catch(() => { this.aPagar.carregando = false; });

      // Compras do mês
      this.$http.get('api/protected/compra/totalizarcomprassemana').then(res => {
        if(res && res.data && res.data.length > 0) {
          const valor = res.data[0].VALOR || 0;
          this.compras.valor = valor;
          this.compras.totalFormatado = this.formatarMoeda(valor);
        }
        this.compras.carregando = false;
      }).catch(() => { this.compras.carregando = false; });

      // Lucro
      this.$http.get('api/protected/venda/totalizarLucroMesAtual').then(res => {
        if(res && res.data && res.data.length > 0) {
          const valor = res.data[0].VALOR || 0;
          this.lucro.valor = valor;
          this.lucro.totalFormatado = this.formatarMoeda(valor);
        }
        this.lucro.carregando = false;
        this.calcularMargem();
      }).catch(() => { this.lucro.carregando = false; });
    },
    abrirResumo(tipo) {
      this.modalResumo.itens = [];
      this.modalResumo.carregando = true;
      this.$bvModal.show('modal-resumo');
      
      if (tipo === 'vendas') {
        this.modalResumo.titulo = 'Melhores Produtos (Mês)';
        this.$http.get('api/protected/venda/listarmelhoresprodutosdasemana').then(res => {
          if (res.data) {
            this.modalResumo.itens = res.data.slice(0, 5).map(i => ({
              titulo: i.DESCRICAO || i.PRODUTO || 'Produto',
              subtitulo: `Qtd: ${i.QUANTIDADE || 0}`,
              valor: i.VALOR || i.TOTAL || 0
            }));
          }
          this.modalResumo.carregando = false;
        }).catch(() => this.modalResumo.carregando = false);
      } 
      else if (tipo === 'areceber') {
        this.modalResumo.titulo = 'Próximos Recebimentos (10 Dias)';
        this.$http.get('api/protected/areceber/listartitulos10dias').then(res => {
          if (res.data) {
            this.modalResumo.itens = res.data.slice(0, 5).map(i => {
              let dataFormatada = '';
              if (i.DATA_FIM) {
                dataFormatada = new Date(i.DATA_FIM).toISOString().substr(0, 10).split('-').reverse().join('/');
              }
              return {
                titulo: i.NOME_CLIENTE || 'Cliente',
                subtitulo: `Doc: ${i.DOCUMENTO || ''} | Venc: ${dataFormatada}`,
                valor: i.VALOR_ABERTO || 0
              };
            });
          }
          this.modalResumo.carregando = false;
        }).catch(() => this.modalResumo.carregando = false);
      }
      else if (tipo === 'apagar') {
        this.modalResumo.titulo = 'Próximos Pagamentos (10 Dias)';
        this.$http.get('api/protected/apagar/listartitulos10dias').then(res => {
          if (res.data) {
            this.modalResumo.itens = res.data.slice(0, 5).map(i => {
              let dataFormatada = '';
              if (i.DATA_FIM) {
                dataFormatada = new Date(i.DATA_FIM).toISOString().substr(0, 10).split('-').reverse().join('/');
              }
              return {
                titulo: i.NOME_CLIENTE || 'Fornecedor',
                subtitulo: `Doc: ${i.DOCUMENTO || ''} | Venc: ${dataFormatada}`,
                valor: i.VALOR_ABERTO || 0
              };
            });
          }
          this.modalResumo.carregando = false;
        }).catch(() => this.modalResumo.carregando = false);
      }
      else if (tipo === 'compras') {
        this.modalResumo.titulo = 'Maiores Fornecedores (Mês)';
        this.$http.get('api/protected/compra/listarmelhoresdasemana').then(res => {
          if (res.data) {
            this.modalResumo.itens = res.data.slice(0, 5).map(i => ({
              titulo: i.NOME || i.FORNECEDOR || 'Fornecedor',
              subtitulo: '',
              valor: i.VALOR || i.TOTAL || 0
            }));
          }
          this.modalResumo.carregando = false;
        }).catch(() => this.modalResumo.carregando = false);
      }
      else if (tipo === 'lucro') {
        this.modalResumo.titulo = 'Composição de Lucro (Mês)';
        this.modalResumo.itens = [
          { titulo: 'Faturamento Bruto', subtitulo: 'Total Vendido', valor: this.vendas.valor },
          { titulo: 'Lucro Líquido Estimado', subtitulo: 'Margem de ' + this.lucro.percentualFormatado, valor: this.lucro.valor }
        ];
        this.modalResumo.carregando = false;
      }
    },
    calcularMargem() {
      if (this.vendas.valor > 0 && this.lucro.valor > 0) {
        const perc = (this.lucro.valor / this.vendas.valor) * 100;
        this.lucro.percentual = perc;
        this.lucro.percentualFormatado = Number(perc).toFixed(2) + '%';
      }
    }
  }
}
</script>

<style scoped>
/* Base Layout */
.executivo-mobile {
  min-height: 100vh;
  background-color: #f4f7f6;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: #333;
  transition: background-color 0.3s ease, color 0.3s ease;
  overflow-x: hidden;
  padding-bottom: 20px;
}

/* Header */
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  transition: background-color 0.3s ease;
}

.notification-icon {
  font-size: 1.4rem;
  color: #6c757d;
  position: relative;
}
.notification-icon::after {
  content: '';
  position: absolute;
  top: 0; right: 0;
  width: 8px; height: 8px;
  background-color: #e3342f;
  border-radius: 50%;
  border: 2px solid #fff;
}

/* Content Area */
.mobile-content-scroll {
  padding: 20px;
}

.section-title {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #888;
  margin-bottom: 12px;
  margin-top: 10px;
  font-weight: 600;
}

/* Cards (Glassmorphism inspired) */
.glass-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.04);
  border: 1px solid rgba(255,255,255,0.4);
  margin-bottom: 25px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

/* Utility Circles */
.icon-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.bg-success-light { background-color: rgba(40, 167, 69, 0.1); }
.bg-info-light { background-color: rgba(23, 162, 184, 0.1); }
.bg-danger-light { background-color: rgba(220, 53, 69, 0.1); }
.bg-warning-light { background-color: rgba(255, 193, 7, 0.15); }

/* Typography */
.metric-value {
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -1px;
  margin-bottom: 10px;
}

.metric-value-sm {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0;
}

.text-light-muted {
  color: #a0aab5 !important;
}

.glass-divider {
  border-top: 1px dashed rgba(0,0,0,0.1);
  margin: 15px 0;
}

/* Mockup Donut Chart CSS */
.donut-chart-mockup {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 8px solid rgba(32, 168, 216, 0.2);
  border-top-color: #20a8d8;
  border-right-color: #20a8d8;
  transform: rotate(45deg);
}

/* ---------------------------------------------------
   DARK MODE OVERRIDES (Luxurious Dark Theme)
   --------------------------------------------------- */
.dark-mode.executivo-mobile {
  background-color: #12121c; /* Deep luxury dark */
  color: #f1f5f9;
}

.dark-mode .mobile-header {
  background-color: #1a1a27;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
}

.dark-mode .notification-icon {
  color: #cbd5e1;
}

.dark-mode .notification-icon::after {
  border-color: #1a1a27;
}

.dark-mode .section-title {
  color: #64748b;
}

.dark-mode .glass-card {
  background: rgba(30, 30, 45, 0.7);
  box-shadow: 0 10px 30px rgba(0,0,0,0.4);
  border: 1px solid rgba(255,255,255,0.03);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}

.dark-mode .metric-value {
  color: #ffffff;
}

.dark-mode .metric-value-sm {
  color: #f1f5f9;
}

.dark-mode .glass-divider {
  border-top: 1px dashed rgba(255,255,255,0.1);
}

.dark-mode .bg-success-light { background-color: rgba(40, 167, 69, 0.2); }
.dark-mode .bg-info-light { background-color: rgba(23, 162, 184, 0.2); }
.dark-mode .bg-danger-light { background-color: rgba(220, 53, 69, 0.2); }
.dark-mode .bg-warning-light { background-color: rgba(255, 193, 7, 0.2); }

/* Progress bar inside dark mode */
.dark-mode .progress {
  background-color: rgba(255,255,255,0.1);
}

.dark-mode .donut-chart-mockup {
  border: 8px solid rgba(255, 255, 255, 0.05);
  border-top-color: #3b82f6;
  border-right-color: #3b82f6;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/DashboardExecutivoMobile.vue